import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
const Ielts = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Exam"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Exam"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"IELTS Exam To Study Abroad"} pagename={"IELTS"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">IELTS</h5>
                            <p className="loan-elegibility-des">The English language competency of the candidate is tested using the International English Language Testing System (IELTS). IELTS evaluates test-takers reading, writing, speaking, and listening understanding, and it is recognized in the majority of nations where English is a spoken language. </p>
                            <h5 className="about-head">Types of IELTS Test</h5>
                            <p className="loan-elegibility-des">IELTS (International English Language Testing System) has two major test formats: IELTS General Training as well as IELTS Academic. You may make a choice between the two based on your own goals and the requirements of the company or institution you are applying to.</p>
                            <ol>
                                <li><b>Academic IELTS Test :</b> Students who wish to study in a country where English is the main spoken language must take the academic IELTS exam. There are frequently four examinations available each month for the Academic IELTS.  Applicants can choose from a list of 55 varied test centers, encompassing a variety of locations, and can be as flexible as possible in selecting their favorite test day from the available options.</li>
                                <li><b>General IELTS Test :</b> The general IELTS exam is required of everyone who is considering moving to an English-speaking nation for work. Twice a month is the general training IELTS exam available. For the suitability of the students, the majority of general IELTS exams are scheduled for Saturdays and Thursdays.</li>
                            </ol>
                            <h5 className="about-head">Conditions for IELTS Eligibility</h5>
                            <p className="loan-elegibility-des">There are no strict requirements to succeed in the IELTS. Rather, the test score indicates a student’s eligibility for numerous universities to take the IELTS exam.</p>
                            <ol>
                                <li><b>IELTS eligibility criteria 2024: Minimum age -</b> The qualifications needed to register for the 2024 IELTS exam vary based on the organization or institution requiring it. However, there is often no age limit to take the IELTS exam. But to register for the IELTS exam, an individual must be at least 16 years old.</li>
                                <li><b>IELTS Eligibility Criteria 2024: Education Qualification -</b> IDP sets no minimal educational criteria for taking the IELTS exam. Regardless of your plans to study, work, or relocate overseas, you are eligible to take the academic or general training version of the IELTS exam.</li>
                            </ol>
                            <p className="loan-elegibility-des">However, applicants must become aware of the admission standards of the university or organization they are applying to. It’s possible that these organizations have requirements specific to eligibility that applicants must fulfill.</p>
                            <h5 className="about-head">Eligibility Requirements for IELTS in Popular Countries</h5>
                            <p className="loan-elegibility-des">The requirements for taking the IELTS exam typically vary depending on the particular needs of the company or educational institution where your IELTS results will be used. An overview of the IELTS qualifying requirements for a few of the most prominent countries may be seen below.</p>
                            <table className="table table-bordered table-striped customtable mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>University</th>
                                        <th>IELTS Bands Required</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Massachusetts Institute of Technology</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>California Institute of Technology</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>Harvard University</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>Princeton University</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>Yale University</td>
                                        <td>7</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 className="about-head">List of the Best Universities in Canada and their IELTS Score Requirements</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>University</th>
                                        <th>Band</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>University of Toronto</td>
                                        <td>7.0</td>
                                    </tr>
                                    <tr>
                                        <td>University of Waterloo</td>
                                        <td>6.6</td>
                                    </tr>
                                    <tr>
                                        <td>University of Alberta</td>
                                        <td>6.5</td>
                                    </tr>
                                    <tr>
                                        <td>McGill University</td>
                                        <td>6.5</td>
                                    </tr>
                                    <tr>
                                        <td>University of British Columbia</td>
                                        <td>6.5</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 className="about-head">Top 5 Universities in the UK and Necessary IELTS Bands</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>University</th>
                                        <th>Band</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>University College London</td>
                                        <td>6.5</td>
                                    </tr>
                                    <tr>
                                        <td>University of Edinburgh</td>
                                        <td>6.5</td>
                                    </tr>
                                    <tr>
                                        <td>University of Oxford</td>
                                        <td>7-7.5</td>
                                    </tr>
                                    <tr>
                                        <td>University of Cambridge</td>
                                        <td>7</td>
                                    </tr>
                                    <tr>
                                        <td>Imperial College London</td>
                                        <td>7</td>
                                    </tr>
                                </tbody>
                            </table>
                            <h5 className="about-head">List of the Best 5 universities in Australia and their Corresponding IELTS Bands</h5>
                            <table className="table table-bordered table-striped customtable">
                                <thead className="table-head">
                                    <tr>
                                        <th>University</th>
                                        <th>Band</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>University of Melbourne</td>
                                        <td>6.5 (with no section score less than 6.0)</td>
                                    </tr>
                                    <tr>
                                        <td>University of Sydney</td>
                                        <td>6.5 (with no band below 6.0)</td>
                                    </tr>
                                    <tr>
                                        <td>University of New South Wales</td>
                                        <td>6.5 (with no band below 6.0)</td>
                                    </tr>
                                    <tr>
                                        <td>University of South Wales</td>
                                        <td>6.0 (with at least 5.5 in each band or equivalent)</td>
                                    </tr>
                                    <tr>
                                        <td>University of Queensland</td>
                                        <td>6.5 (with 6.0 in all sub-band or equivalent)</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">Although a score may be excellent for one university, it may not be the best score for admission to another.<br /><br />

                                IELTS eligibility is subject to a fluctuating trend based on score variations. Students are often recommended to aim for a score of 8.0 band and above because the score band changes, to minimize the possibility of being rejected from the university of their choice. The results are considered by universities as a crucial IELTS qualifying measure for admissions.</p>
                            <h5 className="about-head">IELTS Syllabus</h5>
                            <p className="loan-elegibility-des">The IELTS syllabus for 2024 should be well understood by applicants who wish to receive a better band score on the test.<br /><br />
                                Once a candidate is familiar with the exam format, they may finish the IELTS course in a shorter period. To assist you in achieving an IELTS score of eight or above. </p>
                            <h5 className="about-head">IELTS Reading Syllabus 2024</h5>
                            <p className="loan-elegibility-des">The reading module is divided into three large paragraphs, each of which addresses a topic of wide interest and relevance. There are over 40 questions that assess various aspects of your reading comprehension abilities. Multiple-choice, sentence or summary completion, true, false, or not given question types, and matching lists or phrases are all included in the test.</p>
                            <h5 className="about-head">IELTS Academic: Syllabus for the Reading Test</h5>
                            <p className="loan-elegibility-des">The purpose of the academic reading module is to test students’ understanding and better understanding skills by assigning three paragraphs from books, articles, research papers, etc. Examinees have one hour to respond to questions based on these paragraphs.</p>
                            <h5 className="about-head">IELTS General Training: Exam Syllabus Reading</h5>
                            <p className="loan-elegibility-des">Three paragraphs are also included in the general training reading module. These sentences were probably taken from brochures, company guidelines, or advertisements. Tests for general training and academic reading follow a similar format.</p>
                            <h5 className="about-head">Syllabus for IELTS listening in 2024</h5>
                            <p className="loan-elegibility-des">There are four sections in the IELTS listening section. There will be three-minute audio recordings in each portion featuring interactions, which might contain both dialogue and monologues. There will only be one chance for participants to hear these conversations.<br /><br />
                                There will be diverse types of questions, such as multiple-choice, short-answer, note-completion, sentence-completion, diagram labeling, and more.<br /><br />
                                Please be informed that the syllabus for the IELTS listening test is the same for the academic and general training exams.</p>
                            <h5 className="about-head">The Reading Exam Syllabus for the Academic and General Training IELTS</h5>
                            <p className="loan-elegibility-des">IELTS general training examination, on the other hand, has a coverage of many situations and it deeply probes into how skilled a learner is in the English language. It contains four sections which are intended to evaluate a student’s social and academic understanding of the language.</p>
                            <h5 className="about-head">IELTS writing test syllabus 2024</h5>
                            <p className="loan-elegibility-des">There are two tasks in the IELTS writing test: task 1 and task 2. Examiners have one hour to finish the test. The test’s second task is more important. Just as there is no set list of topics for the writing test, there is no set course of study.</p>
                            <h5 className="about-head">IELTS Academic: Syllabus for the Writing Test</h5>
                            <p className="loan-elegibility-des">The IELTS academic writing test has two questions: task 1 and task 2. The first test activity needs the student to write a report in which they must present the facts they have observed. The information may be displayed as a pie chart, bar graph, flowchart, etc. The second assignment in the test requires the candidate to write an essay on the assigned topic.</p>
                            <h5 className="about-head">IELTS Writing Test Syllabus for General Training</h5>
                            <p className="loan-elegibility-des">The IELTS exam syllabus includes a speaking portion that assesses a student’s ability to communicate with native English speakers in the nation. It is crucial as a student’s entrance to a university may be determined by this area. This part takes ten to fifteen minutes to complete.<br /><br />
                                It should be noted that the syllabus for the IELTS speaking exam has similarities to those of the academic and general training exams.<br /><br />
                                Three categories have been created for the speaking test:</p>
                            <ol className="subhead-ul">
                                <li><b>First Section: Personal interview :</b> It normally lasts four to five minutes and starts with an introduction when questions about personal life and details are asked.</li>
                                <li><b>Second Section: Speech :</b>  In this portion, students are assigned a topic and given one to two minutes to study it. The student then needs to talk for around two minutes on the same subject, during which the examiner will ask questions based on how well you understand the topic.</li>
                                <li><b>Third Section: Discussion :</b> You’ll be asked questions on how well you grasp the subject in part 2 of the interview, which will go into more detail. This takes five to six minutes on average, and students are encouraged to practice it because it has significant importance in the IELTS exam syllabus.</li>
                            </ol>
                            <h5 className="about-head">IELTS Test Format</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Test</th>
                                        <th>Total number of questions	</th>
                                        <th>Duration</th>
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>IELTS Listening Test</td>
                                        <td>3 audios and 40 questions</td>
                                        <td>60 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>IELTS Reading Test</td>
                                        <td>3 paragraphs and 40 questions</td>
                                        <td>60 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>IELTS Writing Test</td>
                                        <td>2 questions</td>
                                        <td>60 minutes</td>
                                    </tr>
                                    <tr>
                                        <td>IELTS Speaking Test</td>
                                        <td>3 rounds</td>
                                        <td>15 - 20 minutes</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Ielts;